<i18n>
{
  "fr": {
    "underage-informations": {
      "title": "Informations sur les mineurs",
      "description": "Tout voyageur français mineur doit être en possession d’un document d’identité à son nom."
    },
    "no-options-for-outward": "Pas d'options disponibles pour l'aller",
    "no-options-for-return": "Pas d'options disponibles pour le retour"
  },
  "en": {
    "underage-informations": {
      "title": "Information about minors",
      "description": "All minor French travellers must be in possession of an identity document in their own name."
    },
    "no-options-for-outward": "No options available for the outward journey",
    "no-options-for-return": "No options available for the return journey"
  }
}
</i18n>

<template>
  <v-container
    fluid
    class="mt-3"
  >
    <v-row no-gutters>
      <v-col
        cols="5"
      >
        <v-list
          dense
          disabled
        >
          <LuggageIncludedInfo
            :outward-included-luggage="outwardIncludedLuggage"
            :return-included-luggage="returnIncludedLuggage"
          />
          <v-list-item v-if="ageAtDeparture < 18">
            <v-list-item-avatar>
              <v-icon color="yellow darken-2">
                mdi-alert-circle
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ $t('underage-informations.title') }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ $t('underage-informations.description') }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col
        cols="7"
      >
        <div
          v-if="(areLuggageOptionsOutward || areLuggageOptionsReturn ) && !areLuggageOptionsCommon"
          class="d-flex"
        >
          <div
            v-if="areLuggageOptionsOutward"
            class="select-and-sentence-container"
          >
            <SelectLuggageOption
              :options-param="inputOptionsParams.OutwardLuggageOptions"
              type-of-flight="outward"
              @input="inputOptionsParams.OutwardLuggageOptions = $event"
            />
            <TotalLuggageSentence
              :options-params="optionsParams"
              option-key="OutwardLuggageOptions"
            />
          </div>
          <div
            v-if="areLuggageOptionsReturn"
            class="select-and-sentence-container"
          >
            <SelectLuggageOption
              :options-param="inputOptionsParams.ReturnLuggageOptions"
              type-of-flight="return"
              @input="inputOptionsParams.ReturnLuggageOptions = $event"
            />
            <TotalLuggageSentence
              :options-params="optionsParams"
              option-key="ReturnLuggageOptions"
            />
          </div>
          <i
            v-if="!areLuggageOptionsOutward"
            class="mt-10 caption grey--text text--lighten-1"
          >{{ $t('no-options-for-outward') }}</i>
          <i
            v-if="!areLuggageOptionsReturn"
            class="mt-10 caption grey--text text--lighten-1"
          >{{ $t('no-options-for-return') }}</i>
        </div>
        <div
          v-if="areLuggageOptionsCommon"
          class="select-and-sentence-container"
        >
          <SelectLuggageOption
            :options-param="inputOptionsParams.LuggageOptions"
            type-of-flight="common"
            @input="inputOptionsParams.LuggageOptions = $event"
          />
          <TotalLuggageSentence
            :options-params="optionsParams"
            option-key="LuggageOptions"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SelectLuggageOption
  from '@/components/Flight/FlightPassengersInformation/FlightLuggageOptions/SelectLuggageOption/SelectLuggageOption'
import TotalLuggageSentence
  from '@/components/Flight/FlightPassengersInformation/FlightLuggageOptions/TotalLuggageSentence/TotalLuggageSentence'
import LuggageIncludedInfo
  from '@/components/Flight/FlightPassengersInformation/FlightTravellerDetails/LuggageOptionsPerPassenger/LuggageIncludedInfo/LuggageIncludedInfo'

export default {
  name: 'LuggageOptionsPerPassenger',
  components: { LuggageIncludedInfo, TotalLuggageSentence, SelectLuggageOption },
  props: {
    ageAtDeparture: {
      type: Number,
      required: true
    },
    outwardIncludedLuggage: {
      type: Object,
      required: true
    },
    returnIncludedLuggage: {
      type: Object,
      default: null
    },
    travelType: {
      type: String,
      required: true
    },
    optionsParams: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    areLuggageOptionsOutward: undefined,
    areLuggageOptionsReturn: undefined,
    areLuggageOptionsCommon: undefined
  }),
  computed: {
    inputOptionsParams: {
      get () {
        return this.optionsParams
      },
      set (value) {
        return this.$emit('input', value)
      }
    }
  },
  created () {
    this.determineOptions()
  },
  methods: {
    determineOptions () {
      if (this.optionsParams) {
        const {
          OutwardLuggageOptions,
          ReturnLuggageOptions,
          LuggageOptions
        } = this.optionsParams

        this.areLuggageOptionsOutward =
            OutwardLuggageOptions?.options &&
            OutwardLuggageOptions?.per_passenger

        this.areLuggageOptionsReturn =
            ReturnLuggageOptions?.options &&
            ReturnLuggageOptions?.per_passenger

        this.areLuggageOptionsCommon =
            LuggageOptions?.options &&
            LuggageOptions?.per_passenger
      }
    }
  }
}
</script>

<style scoped>

.select-and-sentence-container {
  width: 340px;
}

/*do not remove*/
.v-list-item__subtitle {
  white-space: normal;
}

</style>
